import {gql} from '@apollo/client'

export const GET_PATIENT_LIST_DASHBOARD = gql`
  query getScheduledAppointmentListByDate($date: DateTime!) {
    getScheduledAppointmentListByDate(date: $date) {
      id
      patientId
      firstName
      lastName
      profilePhoto
      appointmentType
      slotStart
      slotEnd
    }
  }
`
export const CANCEL_MULTIPLE_SCAN_APPOINTMENT = gql`
  mutation cancelMultipleScanAppointments($appointmentIDList: [ID!]!) {
    cancelMultipleScanAppointments(appointmentIDList: $appointmentIDList){
      summary{
        total
        successful
        failed
      }
    }
  }
`